/* eslint-disable */

import React from 'react'
import {APP} from '../BaseComponent/configTheme'
import http from '../../Component/Interceptor/Interseptor'
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../../../node_modules/bootstrap-v4-rtl/dist/css/bootstrap-rtl.css'
import '../../../node_modules/antd/dist/antd.min.css'
import {Route} from 'react-router-dom'
import Home from '../Home/Home'
import cookie from 'react-cookies'
import Version from '../Beroozresan/Version'
import ActiveDrivers from '../Beroozresan/ActiveDrivers'
import ForgetPass from '../../Component/ForgetPass/ForgetPass'
import Search from '../Search/Search'
import PlanDrivers from '../Search/planDrivers'
import Factors from '../Factors/Factors'
import FactorDrivers from '../Factors/FactorDrivers'
import SetDrivers from '../setDrivers/setDrivers'
import EditFactorDrivers from '../setDrivers/EditFactorDrivers'
import Cars from '../Cars/Cars'
import AddCar from '../Cars/AddCar'
import AllCars from '../Reports/AllCars'
import Reson from '../Reports/Reson'
import PersonReason from '../Reports/PersonReason'
import Payment from '../Reports/Payment'
import Province from '../City/Province'
import Cities from '../City/Cities'
import AddCity from '../Base/AddCity'
import EditCity from '../Base/EditCity'
import Operators from '../Users/Operators'
import Drivers from '../Users/Drivers'
import Products from '../Reports/Products'
import Providers from '../Reports/Providers'
import Remains from '../Reports/Remains'
import Cardex from '../Reports/Cardex'
import Io from '../Reports/Io'
import Dashboard from '../dashboard/Dashboard'
import Profile from '../Profile/Profile'
import AssignedDrivers from '../AssignedDrivers/AssignedDrivers'
import EditDriver from '../EditDriver/EditDriver'
import AddPreRecord from '../wareHouse/addPreRecord'
import WareHouseList from '../wareHouse/WareHouseList'
import PreRecord from '../wareHouse/PreRecord'
import EditPreRecord from '../wareHouse/EditPreRecord'
import ShowPreRecord from '../wareHouse/ShowPreRecord'
import ShowRecord from '../wareHouse/ShowRecord'
import Record from '../wareHouse/Record'
import SubFactors from '../Factors/subFactors'
import OrderStatus from '../OrderStatus/OrderStatus'
import OrderList from '../OrderStatus/OrderList'
import AddWarehouse from '../wareHouse/addWarehouse'
import AddDocType from '../wareHouse/addDocType'
import ListDocs from '../wareHouse/listDocs'
import Baskets from '../Reports/baskets'
import ItemsBascket from '../Reports/itemsBascket'
import PrintBascket from '../PrintPage/PrintBascket'
import UnMatchCardex from '../wareHouse/unMatchCardex'
import DetailsBasket from '../Reports/detailsBasket'
import UnMatchRemain from '../wareHouse/unMatchRemain'
import AddTypeCar from '../Base/AddTypeCar'
import AddReason from '../Base/AddReason'
import AddPersonReason from '../Base/AddPersonReason'
import AddPayment from '../Base/AddPayment'
import AddPaymentReport from '../Reports/AddPaymentReport'
import AddUser from '../Users/AddUser'
import EditProvince from '../Base/EditProvince'
import EditInfoUsers from '../Users/EditInfoUsers'
import TrajectoryDriver from '../mapComponents/TrajectoryDriver'
import AddVersion from '../Base/AddVersion'
import EditVersion from '../Base/EditVersion'
import EditVersionFile from '../Base/editVersionFile'
import EditCar from '../Cars/EditCar'
import EditAssignDriver from '../AssignedDrivers/EditAssignDriver'
import Variable from '../Beroozresan/Variable'
import ProductPlan from '../Factors/ProductPlan'
import ProductPlanFromDispatch from '../Factors/ProductPlanFromDispatch'
import detailsPaid from '../Reports/detailsPaid'
import Statistical from '../Reports/statisticalDriver'
import ReportPaid from '../Reports/ReportPaid'
import AdminMenu from '../TopMenu/AdminMenu'
import LivePosition from '../mapComponents/LivePosition'
import Invoice from '../Reports/Invoice'
import SubInvoice from '../Reports/SubInvoice'
import DetailsInvoice from '../Reports/detailsInvoice'
import RemainReportDriver from '../Reports/RemainReportDriver'
import SupplierOrder from '../Reports/SupplierOrder'
import Mostafa from '../Base/Mostafa'
import FactorProductDispatch from '../Factors/FactorProductDispatch'
import FactorProductPlan from '../Factors/FactorProductPlan'
import SetLeave from '../Beroozresan/setLeave'
import ReportLeave from '../Beroozresan/ReportLeave'
import SmallPrint from '../Base/smallPrint'
import AllFactorsDrivers from '../Reports/allFactorsDrivers'
import Animale from '../Reports/animale'
import DriverBaskets from '../Factors/DriverBaskets'
import ProductDriver from '../Factors/ProductDriver'
import RemainDriver from '../Factors/RemainDriver'
import LastRouteDriver from '../Factors/LastRouteDriver'
import FactorProductByDriver from '../Factors/FactorProductByDriver'
import AddRole from '../Permission/addRole'
import Roles from '../Permission/Roles'
import EditRole from '../Permission/editRole'
import EditPermision from '../Permission/editPermision'
import ReportRemainProvider from '../Reports/ReportRemainProvider'
import Returned from '../setDrivers/Returned'
import AddCrm from '../CRM/addCRM'
import ListCRM from '../CRM/listCRM'
import SubBaskets from '../Reports/SubBaskets'
import ReportUser from '../Reports/reportUser'
import ReportUsers from '../Reports/reportUsers'
import ReportWeight from '../Reports/reportWeight'
import EditCrm from '../CRM/editCRM'
import EditedAddress from '../Reports/EditedAddress'
import PersinaUsers from '../Users/PersinaUsers'
import ReportTransferCost from '../Reports/ReportTransferCost'
import ReportMedia from '../Base/ReportMedia'
import AddMedia from '../Base/AddMedia'
import ReportCategory from '../Base/ReportCategory'
import AddCategory from '../Base/AddCategory'
import ReportSubject from '../Base/ReportSubject'
import AddSubject from '../Base/AddSubject'
import ReportDefinition from '../Base/ReportDefinition'
import AddDefinition from '../Base/AddDefinition'
import ReportPriority from '../Base/reportPriority'
import AddPriority from '../Base/addPriority'
import ReportStatus from '../Base/reportStatus'
import AddStatus from '../Base/addStatus'
import TransferCostByProvider from '../Reports/transferCostByProvider'
import ReportOrderStatus from '../OrderStatus/reportOrderStatus'
import AddOrderStatus from '../OrderStatus/addOrderStatus'
import ReportLocationStatus from '../OrderStatus/reportLocationStatus'
import AddLocationStatus from '../OrderStatus/addLocationStatus'
import PrivateRoute from '../PrivateRoute/PrivateRoute'
import SendMessage from '../Messanger/SendMessage'
import ReceivedMessage from '../Messanger/ReceiveMessage'
import NewMessage from '../Messanger/NewMessage'
import ReportTemplate from '../Messanger/ReportTemplate'
import AddTemplate from '../Messanger/AddTemplate'
import RFML from '../Reports/RFML'
import ReportRejected from '../setDrivers/ReportRejected'
import ReportReAssigned from '../setDrivers/ReportReassigned'
import FinancialSettlement from '../settlement/FinancialSettlement'
import SettlementDrivers from '../settlement/SettlementDrivers'
import WithOutSettleDrivers from '../settlement/WithOutSettleDrivers'
import Inquiry from '../Reports/Inquiry'
import DriverCommissionReport from '../Reports/driverCommissionReport'
import StatisticalDrivers from '../Reports/statisticalDrivers'
import UserTransaction from '../Reports/userTransaction'
import UsersTransaction from '../Reports/usersTransaction'
import RfmlReport from '../Reports/reportRfml'
import UnMatchDeliveryPackAll from '../Reports/unMatchDeliveryPackAll'
import DeliveryPackByTime from '../setDrivers/DeliveryPackByTime'
import DeliveryPackByLocation from '../setDrivers/DeliveryPackByLocation'
import NotLocationNotEdited from '../setDrivers/NotLocationNotEdited'
import NotDelivered from '../setDrivers/NotDelivered'
import ActivityDrivers from '../Search/ActivityDrivers'
import ReportForMali from '../Reports/reportForMali'
import DeliveredMaster from '../Reports/deliveredMaster'
import ParcelLabel from '../Reports/parcelLabel'
import ParcelLabelPrint from '../Reports/parcelLabelPrint'
import DeliveredDetails from '../Reports/deliveredDetails'
import PurchaseCustomer from '../Reports/purhcaseCustomer'
import PurchaseProvider from '../Reports/purchaseProvider'
import PurchaseDeliveryPack from '../Reports/purchaseDeliveryPack'
import ReportSection from '../Tms/ReportSection'
import CreateSection from '../Tms/CreateSection'
import ReportTaskType from '../Tms/ReportTaskType'
import CreateTaskType from '../Tms/CreateTaskType'
import CreateTask from '../Tms/CreateTask'
import ReportTasks from '../Tms/ReportTasks'
import EditTask from '../Tms/EditTask'
import ManageActivity from '../Tms/ManageActivity'
import ReportHistory from '../Tms/ReportHistory'
import ReportOrganization from '../Tms/ReportOrganization'
import CreateOrganization from '../Tms/CreateOrganization'
import {loadAccessToken} from '../Cookie/cookie'
import {loadBrand} from '../BaseComponent/configTheme'
import PurchaseFirstTime from '../Reports/purchaseFirstTime'
import PurchaseMultiPack from '../Reports/purchaseMultiPack'
import FirstDeliveryPack from '../Reports/firstDeliveryPack'
import Dispatch from '../dispatch/dispatch'
import ItemDispatch from '../dispatch/itemDispatch'
import PrintDispatch from '../dispatch/printDispatch'
import SubDispatch from '../dispatch/subDispatch'
import MostSale from '../Reports/mostSale'
import AverageProduct from '../Reports/averageProduct'
import {SendSms} from '../CRM/sendSms'
import NewProducts from '../Reports/newProducts'
import SpeedDriver from '../Users/speedDriver'
import PercentFunctionality from '../Tms/percentFunctionality'
import JalaliFunctionality from '../Tms/jalaliFunctionality'
import ActivityFunctionality from '../Tms/ActivityFunctionality'
import ReportTaskUnit from '../Tms/base/taskReportUnits'
import CreateTaskUnit from '../Tms/base/createTaskUnit'
import DetailsActivityFunctionality from '../Tms/detailsActivityFunctionality'
import ProductOfDriver from '../jasperReport/productOfDriver'
import cartInvoices from '../Reports/cartInvoices'
import cartProducts from '../Reports/cartProduct'
import cartProductsReport from '../Reports/cartProductReport'
import cartProductsReReport from '../Reports/cartProductReReport'
import sortedProductsReport from '../Reports/sortedProductsReport'
import layoutGroupingReport from '../Reports/layoutGroupingReport'
import OrderProvider from '../jasperReport/orderProvider'
import CompleteProductDrivers from '../Reports/completeProductDrivers'
import CompleteProductDriversDetails from '../Reports/completeProductDriversDetails'
import DriverProviders from '../jasperReport/driverProviders'
import ProviderPlans from '../OrderStatus/providerPlans'
import CreateProviderPlan from '../OrderStatus/addProviderPlan'
import EditProviderPlan from '../OrderStatus/editProviderPlan'
import ProductPlanTime from '../Reports/productPlanTime'
import EditPreRecordAutomatic from '../editInvoice/EditPreRecordAutomatic'
import ReportEditedPrerecord from '../editInvoice/reportEditedPrerecord'
import DetailsReportEditedPrerecord from '../editInvoice/detailsReportEditedPrerecord'
import OrderComparisionBaseOrder from '../Reports/orderComparisionBaseOrder'
import OrderComparisionBaseDispatch from '../Reports/orderComparisionBaseDispatch'
import UsersEditedInvoice from '../editInvoice/usersEditedInvoice'
import PhoneShop from '../tellephone/PhoneShop'
import Banks from '../payment/base/Banks'
import AddBank from '../../Component/payment/base/AddBank'
import Terminals from '../../Component/payment/base/Terminal'
import AddTerminal from '../../Component/payment/base/AddTerminal'
import UploadExcell from '../payment/base/UploadExcell'
import EditTerminal from '../../Component/payment/base/EditTerminal'
import TerminalHistory from '../Reports/TerminalHistory'
import MasterTerminal from '../payment/base/MasterTerminal'
import DetailTerminal from '../payment/base/DetailTerminal'
import PackageShop from '../tellephone/packageShop'
import ReportDriverCard from '../Users/reportDriverCard'
import ListAllPackages from '../tellephone/listAllPackages'
import ReportCustomerCard from '../Club/reportCustomerCard'
import Club from '../Club/club'
import ReportDuplicated from '../Tms/reportDuplicated'
import SuppliedPercent from '../Reports/suppliedPercent'
import SuppliedNotice from '../Reports/suppliedNotice'
import ReportOil from '../oil/reportOil'
import PrintLabel from '../PrintPage/PrintLabel'
import PrintBascketA4 from '../PrintPage/prinkBascketA4'
import PrintBascketA4Les8Factor from '../PrintPage/printBascketA4Les8Factor'
import A4Print from '../PrintPage/A4Print'
import PrintRole from '../PrintPage/printRole'
import MasterSupplyOrder from '../Reports/masterSupplyOrder'
import CartStation from '../cartStation'
import CreateCartStation from '../cartStation/create'
import DriverCartStation from '../cartStationDriver'
import CreateDriverCartStation from '../cartStationDriver/create'
import EditDriverCartStation from '../cartStationDriver/edit'
import DeliveryStatusList from '../deliveryStatus/deliveryStatusList'
import CreateDeliveryStatus from '../deliveryStatus/createDeliveryStatus'
import CreateLocationStatus from '../deliveryStatus/createLocationStatus'
import LocationStatusList from '../deliveryStatus/locationStatusList'
import DeliveryStatusReport from '../deliveryStatus/deliveryStatusReport'
import WarehouseLink from '../wareHouse/warehouseLink'
import CreateDelivery from '../deliveryStatus/createDelivery'
import {Helmet} from 'react-helmet'
import SupplyOrderIncomplete from '../Reports/supplyOrderIncomplete'
import OrderDispatchIncomplete from '../Reports/orderDispatchIncomplete'
import SupplyOrderStatus from '../Reports/supplyOrderStatus'
import SendSmsHr from '../sms/sendSmsHr'
import SendSmsCrm from '../sms/sendSmsCrm'
import ReportSmsCrm from '../sms/reportSmsCrm'
import ReportSmsHr from '../sms/reportSmsHr'
import AddRecordInternal from '../wareHouse/addRecordInternal'
import CreateFamilyStatus from '../deliveryStatus/createFamilyStatus'
import ReportFamilyStatus from '../deliveryStatus/reportFamilyStatus'
import EditFamilyStatus from '../deliveryStatus/editFamilyStatus'
import ListShortageDriver from '../jasperReport/listShortageDriver'
import DriverShortage from '../Reports/driverShortage'
import ProductsDepot from '../Reports/productsDepot'
import WarehouseProductPrice from '../jasperReport/warehouseProductPrice'
import EditDelivery from '../deliveryStatus/editDelivery'
import CurrnetDifference from '../jasperReport/currentDifference'
import WarehouseProductPriceDepot from '../jasperReport/warehouseproductPriceDepot'
import ReportProcessCategory from '../deliveryStatus/reportProcessCategory'
import CreateProcessCategory from '../deliveryStatus/createProcessCategory'
import EditProcessCategory from '../deliveryStatus/editProcessCategory'
import MyDeliveryStatus from '../deliveryStatus/myDeliveryStatus'
import ImportOpTime from '../setDrivers/importOpTime'
import NegativeSupplyOrder from '../jasperReport/negetiveSupplyOrder'
import WarehouseProductPriceByProvider from '../jasperReport/warehouseProductPriceByProvider'
import CallToBuy from '../Reports/callToBuy'
import ProductPriceDepotPeriodic from '../jasperReport/productPriceDepotPeriodic'
import DepotProductPriceCustomer from '../Reports/depotProductPriceToCustomer'
import ProviderIo from '../Reports/providerIo'
import CustomerIo from '../Reports/customerIo'
import ManagerCreateTask from '../Tms/ManagerCreateTask'

export default class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isAuthenticated: true
    }
  }
  componentDidMount() {
    document.title = loadBrand().title

    if (loadAccessToken()) {
      http
        .get(`user/profile/status`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              isAuthenticated: true
            })
          } else {
            this.setState({
              isAuthenticated: false
            })
          }
        })
        .catch(() => {})
    } else {
      this.setState({
        isAuthenticated: false
      })
    }
  }

  render() {
    return (
      <div className="rtl">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{APP.name}</title>
        </Helmet>
        <AdminMenu />
        <Route path="/" exact={true} component={Home} />
        <PrivateRoute path="/version" component={Version} auth={this.state.isAuthenticated} />
        <PrivateRoute path="/productColumns" component={Animale} auth={this.state.isAuthenticated} />
        <PrivateRoute path="/smallPrint" component={SmallPrint} auth={this.state.isAuthenticated} />
        <PrivateRoute path="/transferCost" component={Mostafa} auth={this.state.isAuthenticated} />
        <PrivateRoute path="/variable" component={Variable} auth={this.state.isAuthenticated} />
        <PrivateRoute path="/ActiveDrivers" component={ActiveDrivers} auth={this.state.isAuthenticated} />
        <Route path={'/ForgetPass'} component={ForgetPass} />
        <PrivateRoute path={'/Search'} component={Search} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={`/PlanDrivers/:driverId/:name`}
          component={PlanDrivers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path="/Factors" component={Factors} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path="/productPlan/:planId/:planDate/:planTimeFrom/:planTimeTo"
          component={ProductPlan}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path="/ProductDriver/:personId/:planDateMin/:planDateMax/:name/:dayPartId"
          component={ProductDriver}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path="/ProductPlanFromDispatch/:dispatchId/:name/:planDate"
          component={ProductPlanFromDispatch}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path="/FactorProductDispatch/:productId/:providerName/:productName/:name/:planDate"
          component={FactorProductDispatch}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path="/FactorProductDriver/:personId/:planDateMin/:planDateMax/:productId/:providerName/:productName/:dayPartId"
          component={FactorProductByDriver}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path="/FactorProductPlan/:productId/:providerName/:productName/:planDate"
          component={FactorProductPlan}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path="/subFactors/:deliveryPackId" component={SubFactors} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path="/DriverFactor/:dispatchId/:name/:planDate?"
          component={FactorDrivers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path="/DriverBasket" component={DriverBaskets} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/SetDrivers/:planId'} component={SetDrivers} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/returnedPlans/returned'} component={Returned} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/returnedPlans/report/rejected'}
          component={ReportRejected}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/returnedPlans/report/reAssign'}
          component={ReportReAssigned}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/EditFactorDrivers/:dispatchId/driver=:driverId/:name/:planId'}
          component={EditFactorDrivers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/EditDriver'} component={EditDriver} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/editAssignedDriver/:dispatchId/driver=:personId/car=:carId'}
          component={EditAssignDriver}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/Cars'} component={Cars} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/AddCar'} component={AddCar} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/EditCar/:carId'} component={EditCar} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/Reson'} component={Reson} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/PersonReason'} component={PersonReason} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/Payment'} component={Payment} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/AllCars'} component={AllCars} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/Products'} component={Products} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/Providers'} component={Providers} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/Remains'} component={Remains} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/Cardex'} component={Cardex} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/warehouseIo'} component={Io} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/report/io/byProvider'} component={ProviderIo} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/report/io/byCustomer'} component={CustomerIo} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/Cities'} component={Cities} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addCity'} component={AddCity} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/editCity/:cityId'} component={EditCity} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addTypeCar'} component={AddTypeCar} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addReason'} component={AddReason} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addPersonReason'} component={AddPersonReason} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addPayment'} component={AddPayment} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/AddPaymentReport'} component={AddPaymentReport} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addVersion'} component={AddVersion} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/EditVersion/:id'} component={EditVersion} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/EditVersionFile/:id'} component={EditVersionFile} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addUser'} component={AddUser} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addRole'} component={AddRole} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/editRole/:roleId'} component={EditRole} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/roles'} component={Roles} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/editInfoUsers/:personId'}
          component={EditInfoUsers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/Province'} component={Province} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/editProvince/:provinceId'} component={EditProvince} />
        <PrivateRoute path={`/Operators/:role?`} component={Operators} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={`/base/users/persina/:userCode?`}
          component={PersinaUsers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/Drivers'} component={Drivers} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/manage/driver/list'} component={SpeedDriver} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/trajectory/:driverId/:driverName'}
          component={TrajectoryDriver}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/livePosition/driver=:driverId'}
          component={LivePosition}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/LastRouteDriver/:personId/:name/:dayPartId'}
          component={LastRouteDriver}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/addPreRecord'} component={AddPreRecord} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/addRecord/internal/:preDocId'}
          component={AddRecordInternal}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/WareHouseList'} component={WareHouseList} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/AddWarehouse'} component={AddWarehouse} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addDocType'} component={AddDocType} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/listDocType'} component={ListDocs} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/PreRecord'} component={PreRecord} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/RemainReportDriver'}
          component={RemainReportDriver}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/RemainDriver/:personId/:planDateMin/:planDateMax/:name/:dayPartId'}
          component={RemainDriver}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/EditPreRecord/:preWarehouseDocId'}
          component={EditPreRecord}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/ShowPreRecord/:preWarehouseDocId'}
          component={ShowPreRecord}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/ShowRecord/:preWarehouseDocId/:natureDocNo'}
          component={ShowRecord}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/Record'} component={Record} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/SupplierOrder'} exact component={SupplierOrder} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/AssignedDrivers/:planId/:planDate/:planDateFrom/:planDateTo'}
          component={AssignedDrivers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/Dashboard'} exact component={Dashboard} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/Profile'} component={Profile} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/orderStatus'} component={OrderStatus} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/orderList'} component={OrderList} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/baskets'}
          search={`?invoiceId=:invoiceId&userCode=:userCode&deliveryPackId=:deliveryPackId`}
          component={Baskets}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/subBaskets'} component={SubBaskets} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/Invoice'} component={Invoice} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/SubInvoice'} component={SubInvoice} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/detailsInvoice/:invoiceId/:invoiceNum/:buyerName'}
          component={DetailsInvoice}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/printBaskets'} component={PrintBascket} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/printLabel'} component={PrintLabel} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/printRoll'} component={PrintRole} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/printBasketsA4'} component={PrintBascketA4} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/printBascketA4Les8Factor'}
          component={PrintBascketA4Les8Factor}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/a4Print'} component={A4Print} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/itemBascket/:deliveryPackId/:invoiceId/:invoiceNum/:buyerName'}
          component={ItemsBascket}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/detailsBasket'} component={DetailsBasket} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/detailsPaid/:detailId/:invoiceId/:name/:driverId'}
          component={detailsPaid}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/unMatchCardex'} component={UnMatchCardex} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/statisticalDriver/driverId=:personId/driverName=:driverName'}
          component={Statistical}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/statisticalDrivers'}
          component={StatisticalDrivers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/unMatchRemain'} component={UnMatchRemain} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/ReportPaid'} component={ReportPaid} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/setLeave'} component={SetLeave} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/reportLeave'} component={ReportLeave} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/allFactorsDrivers'} component={AllFactorsDrivers} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/editPermission'} component={EditPermision} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/reportRemainProvider'}
          component={ReportRemainProvider}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/CRM/add'} component={AddCrm} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/CRM/list'} component={ListCRM} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/CRM/sendSms'} component={SendSms} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/editCRM/:CrmId'} component={EditCrm} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/reportUser'}
          search={`?userCode=:userCode`}
          component={ReportUser}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/reportUsers'} component={ReportUsers} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/reportWeight'} component={ReportWeight} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/editedAddress'} component={EditedAddress} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/reportTransferCost'}
          component={ReportTransferCost}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/transferCostByProvider'}
          component={TransferCostByProvider}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/reportMedia'} component={ReportMedia} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addMedia'} component={AddMedia} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/reportCategory'} component={ReportCategory} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addCategory'} component={AddCategory} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/reportSubject'} component={ReportSubject} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addSubject'} component={AddSubject} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/reportDefinition'} component={ReportDefinition} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addDefinition'} component={AddDefinition} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/reportPriority'} component={ReportPriority} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addPriority'} component={AddPriority} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/reportStatus'} component={ReportStatus} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addStatus'} component={AddStatus} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/base/orderStatus/reportOrderStatus'}
          component={ReportOrderStatus}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/orderStatus/addOrderStatus'}
          component={AddOrderStatus}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/orderStatus/reportLocationStatus'}
          component={ReportLocationStatus}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/orderStatus/provider/plans'}
          exact
          component={ProviderPlans}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/orderStatus/provider/plans/create'}
          exact
          component={CreateProviderPlan}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/orderStatus/provider/plans/edit/:id'}
          exact
          component={EditProviderPlan}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/base/deliveryLocation/addDeliveryLocation'}
          component={AddLocationStatus}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/messanger/report/send'} component={SendMessage} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/messanger/report/received'}
          component={ReceivedMessage}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/messanger/newMessage'} component={NewMessage} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/base/messanger/reportTemplate'}
          component={ReportTemplate}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/messanger/addTemplate'}
          component={AddTemplate}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/reportHistoryBought'} component={RFML} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/financial/settlement'}
          component={FinancialSettlement}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/settlement/drivers'}
          component={SettlementDrivers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/settlement/withOutSettleDrivers'}
          component={WithOutSettleDrivers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/inquiry'} component={Inquiry} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/driver-commission-report'}
          component={DriverCommissionReport}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/user/transaction'}
          search={`?userCode=:userCode`}
          component={UserTransaction}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/users/transaction'}
          component={UsersTransaction}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/report/rfml'} component={RfmlReport} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/report/incompatible/deliveryPackAll'}
          component={UnMatchDeliveryPackAll}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/delivery/time'}
          component={DeliveryPackByTime}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/delivery/location'}
          component={DeliveryPackByLocation}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/delivery/notEdited'}
          component={NotLocationNotEdited}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/delivery/NotDelivered'}
          component={NotDelivered}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/ActivityDrivers'}
          component={ActivityDrivers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/report/forMali'} component={ReportForMali} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/report/delivery/delivered'}
          component={DeliveredMaster}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/report/parcel/label'} component={ParcelLabel} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/report/parcel/print-label'}
          component={ParcelLabelPrint}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/deliveryDetails/:deliveryPackId/:invoiceNum/:invoiceId/:buyerName/:detailId'}
          component={DeliveredDetails}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/purchase/customer'}
          component={PurchaseCustomer}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/purchase/provider'}
          component={PurchaseProvider}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/purchase/deliveryPack'}
          component={PurchaseDeliveryPack}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/base/report/tms/sections'}
          component={ReportSection}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/create/tms/sections'}
          component={CreateSection}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/report/tms/taskType'}
          component={ReportTaskType}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/create/tms/taskType'}
          component={CreateTaskType}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/report/tms/department'}
          component={ReportOrganization}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/create/tms/department'}
          component={CreateOrganization}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/base/report/tms/taskUnit'}
          component={ReportTaskUnit}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/create/tms/taskUnit'}
          component={CreateTaskUnit}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute path={'/tms/task/create'} component={CreateTask} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/tms/task/edit/:id'} component={EditTask} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/tms/task/report'} component={ReportTasks} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/tms/manageTask/create'}
          component={ManagerCreateTask}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/tms/manageTask/report'}
          component={ManageActivity}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/tms/manageTask/history/:activityId?'}
          component={ReportHistory}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/tms/task/percent/functionality'}
          component={PercentFunctionality}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/tms/task/jalali/functionality'}
          component={JalaliFunctionality}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/tms/report/activity/functionality'}
          component={ActivityFunctionality}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/tms/report/duplicated'}
          component={ReportDuplicated}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/detailsFunctionality'}
          search={`?id=:id&fromDate=:fromDate&toDate=:toDate`}
          component={DetailsActivityFunctionality}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/purchase/firstTime'}
          component={PurchaseFirstTime}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/purchase/multiPack'}
          component={PurchaseMultiPack}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/purchase/firstDeliveryPack'}
          component={FirstDeliveryPack}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute path={'/dispatch'} component={Dispatch} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/itemDispatch/:deliveryPackId/:invoiceId/:invoiceNum/:buyerName'}
          component={ItemDispatch}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/printDispatch'} component={PrintDispatch} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/subDispatch'} component={SubDispatch} auth={this.state.isAuthenticated} />

        <PrivateRoute
          path={'/report/retail/purchase/byTime'}
          component={MostSale}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/retail/purchase/invoiceItem'}
          component={AverageProduct}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/retail/purchase/product'}
          component={NewProducts}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/jasper/product/driver'}
          component={ProductOfDriver}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/jasper/cart/invoices'}
          component={cartInvoices}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/jasper/cart/products'}
          component={cartProducts}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/jasper/cart/products-report'}
          component={cartProductsReport}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/jasper/cart/products-re-report'}
          component={cartProductsReReport}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/jasper/cart/sorted-products'}
          component={sortedProductsReport}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/jasper/cart/layout-grouping'}
          component={layoutGroupingReport}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/jasper/order/provider'}
          component={OrderProvider}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/driver/completeProductDriver'}
          component={CompleteProductDrivers}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/driver/complete/ProductDriver/details/:id/:planDateMin/:planDateMax/:name'}
          component={CompleteProductDriversDetails}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/jasper/driver/providers'}
          component={DriverProviders}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/supplier/products/plans/time'}
          exact
          component={ProductPlanTime}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/edit/unmatch/invoice/remain'}
          exact
          component={EditPreRecordAutomatic}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/edited/invoice'}
          exact
          component={ReportEditedPrerecord}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/showDetails/edited/invoice/:id'}
          search={`?createDate=:createDate&rolledBackTime=:rolledBackTime`}
          exact
          component={DetailsReportEditedPrerecord}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/customer/edited/invoice'}
          exact
          component={UsersEditedInvoice}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/orderComparision/baseOnOrder'}
          exact
          component={OrderComparisionBaseOrder}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/orderComparision/baseOnDispatch'}
          exact
          component={OrderComparisionBaseDispatch}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute path={'/Base/payment/banks'} exact component={Banks} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/addbank'} component={AddBank} auth={this.state.isAuthenticated} />

        <PrivateRoute
          path={'/Base/payment/terminals'}
          exact
          component={Terminals}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/addterminal'} exact component={AddTerminal} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/editterminal/:id'} exact component={EditTerminal} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/Report/TerminalHistory'}
          exact
          component={TerminalHistory}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/upload'} exact component={UploadExcell} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/masterReport'} exact component={MasterTerminal} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/masterDetail/:id'}
          exact
          component={DetailTerminal}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/manage/driver/reportCard'}
          exact
          component={ReportDriverCard}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/Club/customer/reportCard'}
          exact
          component={ReportCustomerCard}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/Club/Club'} exact component={Club} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/report/retail/supplied/percent'}
          exact
          component={SuppliedPercent}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/retail/supplied/notices'}
          exact
          component={SuppliedNotice}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/report/oil'} exact component={ReportOil} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/master/supplyOrder'}
          exact
          component={MasterSupplyOrder}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/cartStation/report'}
          exact
          component={CartStation}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/cartStation/create'}
          exact
          component={CreateCartStation}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/driverCartStation/report'}
          exact
          component={DriverCartStation}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/driverCartStation/create'}
          exact
          component={CreateDriverCartStation}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/driverCartStation/edit/:id'}
          exact
          component={EditDriverCartStation}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/base/deliveryStatus/reportDeliveryStatus'}
          component={DeliveryStatusList}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/deliveryStatus/addDeliveryStatus'}
          component={CreateDeliveryStatus}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/base/deliveryStatus/reportLocationStatus'}
          component={LocationStatusList}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/deliveryStatus/addLocationStatus'}
          component={CreateLocationStatus}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/deliveryStatus/report'}
          component={DeliveryStatusReport}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/deliveryStatus/my'} component={MyDeliveryStatus} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/deliveryStatus/add'} component={CreateDelivery} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/deliveryStatus/edit/:id'}
          component={EditDelivery}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute path={'/warehouse/link'} component={WarehouseLink} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/supplyOrder/incomplete'}
          component={SupplyOrderIncomplete}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/negative/supply-orders'}
          component={NegativeSupplyOrder}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/orderDispatch/incompatible'}
          component={OrderDispatchIncomplete}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/supplyOrder/orderStatus'}
          component={SupplyOrderStatus}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/CRM/sms/hr/send'} component={SendSmsHr} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/CRM/sms/hr/report'} component={ReportSmsHr} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/CRM/sms/crm/send'} component={SendSmsCrm} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/CRM/sms/crm/report'} component={ReportSmsCrm} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/base/deliveryStatus/createFamilyStatus'}
          component={CreateFamilyStatus}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/deliveryStatus/familyStatusChanges'}
          component={ReportFamilyStatus}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/deliveryStatus/editFamilyStatus/:id'}
          component={EditFamilyStatus}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/deliveryStatus/processCategories'}
          component={ReportProcessCategory}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/deliveryStatus/createProcessCategories'}
          component={CreateProcessCategory}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/base/deliveryStatus/editProcessCategories/:id'}
          component={EditProcessCategory}
          auth={this.state.isAuthenticated}
        />

        <PrivateRoute
          path={'/report/listShortageDriver'}
          component={ListShortageDriver}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/driver/shortage'}
          component={DriverShortage}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/report/products/depot'} component={ProductsDepot} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/warehouse/products/price'}
          component={WarehouseProductPrice}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/report/depot/productPrice/toCustomer'}
          component={DepotProductPriceCustomer}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/warehouse/products/byMonth/price'}
          component={WarehouseProductPriceByProvider}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/warehouseDepots/products/price/depot'}
          component={WarehouseProductPriceDepot}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute
          path={'/warehouse/current/difference'}
          component={CurrnetDifference}
          auth={this.state.isAuthenticated}
        />
        <PrivateRoute path={'/assign/by/opTime'} component={ImportOpTime} auth={this.state.isAuthenticated} />
        <PrivateRoute path={'/call-to-buy/master'} component={CallToBuy} auth={this.state.isAuthenticated} />
        <PrivateRoute
          path={'/productPrice/depot/periodic'}
          component={ProductPriceDepotPeriodic}
          auth={this.state.isAuthenticated}
        />

        <Route path={'/singleProduct/:id'} search={`?msisdn=:mobile`} exact={true} component={PhoneShop} />
        <Route path={'/Vitrin/:id'} search={`?msisdn=:mobile`} exact={true} component={PackageShop} />
        <Route path={'/packages'} search={`?msisdn=:mobile`} exact={true} component={ListAllPackages} />
      </div>
    )
  }
}
